// Hooks
import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";

// Components
import ProductCard from "@/components/ProductCard";

// Utils & Libs
import breakPoint from "./swiper-breakpoint.json";
import SwiperCore, {Navigation, Scrollbar} from "swiper";
import getID from "@/utils/getID";
SwiperCore.use([Scrollbar]);

// Assets
import "swiper/css";
import {IHomeDataResponse} from "@/types/home.types";
import classNames from "classnames";

// Types

const HomeMustHaveProduct: React.FC<{data: IHomeDataResponse}> = ({data}) => {
  return (
    <section className="flex flex-col mt-5 overflow-hidden md:overflow-visible md:flex-row md:mt-16 md:space-x-8 wrapper product-highlight-container">
      <section className="md:w-[46%] z-50">
        <picture>
          <source media="(min-width:768px)" srcSet={data?.image_section1.image} />
          <img
            className="object-cover w-full h-full"
            src={data?.image_section1?.image_mobile}
            alt={data?.image_section1?.title}
          />
        </picture>
      </section>

      {/* slider */}
      <section className="md:w-[54%] relative flex mt-5 md:mt-0 flex-col must-have-wrapper">
        <div className="">
          <Swiper
            navigation={{
              prevEl: ".prev-must-have-prod",
              nextEl: ".next-must-have-prod",
            }}
            scrollbar={{
              el: ".swiper-scrollbar",
              hide: true,
              draggable: true,
            }}
            breakpoints={breakPoint}
            slidesPerView="auto"
            modules={[Navigation, Scrollbar]}
            className="w-full overflow-visible"
          >
            {data.products_section1.map((product) => (
              <SwiperSlide key={getID()}>
                <ProductCard data={product} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* actions */}

        <section
          className={classNames(
            {
              invisible: !data.products_section1.length,
            },
            "flex flex-row items-center gap-5 mt-12"
          )}
        >
          {/* slider */}
          <div className="w-full overflow-hidden">
            <div className="relative w-full opacity-100 swiper-scrollbar"></div>
          </div>

          {/* arrow */}
          <div className="flex space-x-2 min-w-fit">
            <button className="max-w-[55px] bg-transparent prev-must-have-prod">
              <img src="/icons/rounded-bordered-arrow-left.svg" alt="arrow-left-icon" />
            </button>
            <button className="max-w-[55px] bg-transparent next-must-have-prod">
              <img className="rotate-180" src="/icons/rounded-bordered-arrow-left.svg" alt="arrow-left-icon" />
            </button>
          </div>
        </section>
      </section>
    </section>
  );
};

export default HomeMustHaveProduct;
